const prefix = '[partner details] ';

export const CHANGE_PARTNER = `${prefix}CHANGE_PARTNER`;

// new-activity
export const RESET_SELECTED_RATE = `${prefix}RESET_SELECTED_RATE`;
export const RESET_SELECTED_LOCATION = `${prefix}RESET_SELECTED_LOCATION`;
export const RESET_SELECTED_ALL = `${prefix}RESET_SELECTED_RATE_ALL`;
export const SEND_RATES = `${prefix}SEND_RATES`;
export const SEND_RATE_REQUESTS = `${prefix}SEND_RATE_REQUEST`;
export const SEND_MESSAGE = `${prefix}SEND_MESSAGE`;
export const RESET_CONTRACTING_REQUEST = `${prefix}RESET_CONTRACTING_REQUEST`;

// activities
export const GET_ACTIVITY = `${prefix}GET_ACTIVITY`;

// files
export const GET_FILES = `${prefix}GET_FILES`;

// PartnerInfo
export const GET_PARTNER_INFO = `${prefix}GET_PARTNER_INFO`;

export const CLEAR_STORE = `${prefix}CLEAR_STORE`;



// WEBPACK FOOTER //
// ./src/app/components/partner-details/__store__/constants.js